module.exports = __webpack_public_path__ + "b993e3c4610dd445a362545ce2c811b4.png";